// https://app.growthbook.io/features/flw-1235_v2
export const EXPERIMENT_FLAG = 'flw-1235_v2'

export const GLOBAL_NAV_I18N_NS = '@mc/global-navigation'
